export enum ROLE {
  HO_ADMIN = "HO_ADMIN",
  HO_USER = "HO_USER",
  FA_ADMIN = "FA_ADMIN",
  FA_USER = "FA_USER",
}

export enum USER_TYPE {
  CSO = "CSO",
  ACSO = "ACSO",
  BDO = "BDO",
  AH = "AH",
  SH = "SH",
  RM = "RM",
  HO = "HO",
  AAH = "AAH",
}

export enum FA_USER_TYPE {
  CI = "CI",
  TELE_CALLER = "TELE_CALLER",
  CENTRE_MANAGER = "CENTRE_MANAGER",
}
